import axios from 'axios';
import configuracion from "../data/configuracion"

// Configuración base para Axios
const Apibig = axios.create({
  baseURL: configuracion.urlapi,
  headers: {
    'Content-Type': 'application/json',
  }
});
export default Apibig